import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { IMaterialItem } from '../../interfaces/news';
import { getMaterialsHighlightsNews, INewsParams } from '../../services/news';

export interface IState {
  list: IMaterialItem[];
  error: boolean;
}

const initialState: IState = {
  list: [],
  error: false,
};

export const fetchNewsHighlights = createAsyncThunk('news/fetchHighlights', async (params: INewsParams) => {
  return await getMaterialsHighlightsNews(params);
});

const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchNewsHighlights.fulfilled, (state, { payload }) => {
      state.list = payload.items;
    });
    builder.addCase(fetchNewsHighlights.rejected, (state, { payload }) => {
      state.error = !!payload;
    });
  },
});

const { reducer } = newsSlice;

export default reducer;
